import { z } from 'zod'

export const MentalStatusExaminationFormSchema = z.object({
  APPEARANCE: z.union([
    z.literal('NEAT'),
    z.literal('DISHEVELED'),
    z.literal('INAPPROPRIATE'),
    z.literal('BIZARRE'),
    z.literal('OTHER'),
  ]),
  SPEECH: z.union([
    z.literal('NORMAL'),
    z.literal('TANGENTIAL'),
    z.literal('PRESSURED'),
    z.literal('IMPOVERISHED'),
    z.literal('OTHER'),
  ]),
  EYE_CONTACT: z.union([z.literal('NORMAL'), z.literal('INTENSE'), z.literal('AVOIDANT'), z.literal('OTHER')]),
  MOTOR_ACTIVITY: z.union([
    z.literal('NORMAL'),
    z.literal('RESTLESS'),
    z.literal('TICS'),
    z.literal('SLOWED'),
    z.literal('OTHER'),
  ]),
  AFFECT: z.union([
    z.literal('FULL'),
    z.literal('CONSTRAINED'),
    z.literal('FLAT'),
    z.literal('LABILE'),
    z.literal('OTHER'),
  ]),
  MOOD: z.union([
    z.literal('EUTHYMIC'),
    z.literal('ANXIOUS'),
    z.literal('ANGRY'),
    z.literal('DEPRESSED'),
    z.literal('EUPHORIC'),
    z.literal('IRRITABLE'),
    z.literal('OTHER'),
  ]),
  ORIENTATION_IMPAIRMENT: z.union([
    z.literal('NONE'),
    z.literal('PLACE'),
    z.literal('OBJECT'),
    z.literal('PERSON'),
    z.literal('TIME'),
  ]),
  MEMORY_IMPAIRMENT: z.union([z.literal('NONE'), z.literal('SHORT_TERM'), z.literal('LONG_TERM'), z.literal('OTHER')]),
  ATTENTION: z.union([z.literal('NORMAL'), z.literal('DISTRACTED'), z.literal('OTHER')]),
  HALLUCINATIONS: z.union([z.literal('NONE'), z.literal('AUDITORY'), z.literal('VISUAL'), z.literal('OTHER')]),
  DELUSIONS: z.union([
    z.literal('NONE'),
    z.literal('GRANDIOSE'),
    z.literal('PARANOID'),
    z.literal('RELIGIOUS'),
    z.literal('OTHER'),
  ]),
  BEHAVIOR: z.union([
    z.literal('COOPERATIVE'),
    z.literal('GUARDED'),
    z.literal('HYPERACTIVE'),
    z.literal('AGITATED'),
    z.literal('PARANOID'),
    z.literal('STEREOTYPED'),
    z.literal('AGGRESSIVE'),
    z.literal('BIZARRE'),
    z.literal('WITHDRAWN'),
    z.literal('OTHER'),
  ]),
  INSIGHT_JUDGMENT: z.union([z.literal('GOOD'), z.literal('FAIR'), z.literal('INAPPROPRIATE')]),
  ADDITIONAL_MSE_NOTES: z.string().min(1).optional(),
})
